(() => {
  const root = document.querySelector('.ink-page-second');
  if (!root) return;

  const intro = root.querySelector('section:first-of-type');
  if (intro) {
    intro.dataset.component = 'second-page-intro';
    const introCopy = intro.querySelector(':scope > div:nth-child(2)');
    if (introCopy) introCopy.dataset.component = 'second-page-intro-copy';
  }

  const normalizeText = (value) => (value || '').replace(/\s+/g, ' ').trim();
  // ページhandleは `/pages/{handle}` から取る。末尾スラッシュや言語プレフィックス
  // 付きURLでも正本データのキーと一致させる。
  const pageHandle = (() => {
    const matched = window.location.pathname.match(/(?:^|\/)pages\/([^/]+)\/?$/);
    if (!matched) return null;
    try {
      return decodeURIComponent(matched[1]).toLowerCase();
    } catch {
      return matched[1].toLowerCase();
    }
  })();
  // 正本データと現行件数が食い違うときは移行本文を残す。差異は必ずログに出す。
  const catalogIsComplete = (label, actual, expected) => {
    if (actual === expected) return true;
    console.warn(`[second-page] ${label} の件数が正本と一致しません (${actual}/${expected})。一覧の置き換えを中止しました。`);
    return false;
  };
  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  })[char]);

  // 移行本文に残る自己参照を、同じメーカーのプリンター型番ページへ補正する。
  const tonerPrinterTargets = {
    'epson-t': '/pages/epsonprinter-t',
    'canon-t': '/pages/canonprinter-t',
    'brother-t': '/pages/brotherprinter-t',
    'ricoh-t': '/pages/ricoh-printer-t',
    'other-toner': '/pages/others-printer-t',
  };
  const tonerPrinterTarget = pageHandle ? tonerPrinterTargets[pageHandle] : null;
  if (tonerPrinterTarget) {
    root.querySelectorAll('a').forEach((link) => {
      if (/プリンター型番から探す方はこちら/.test(normalizeText(link.textContent))) {
        link.href = tonerPrinterTarget;
      }
    });
  }

  // 検索欄はレイアウト確認用。Shopifyの検索ロジックには接続しない。
  root.querySelectorAll('[data-component="second-page-model-number-search"]').forEach((searchUi) => {
    searchUi.dataset.uiOnly = '';
    searchUi.querySelectorAll('form').forEach((form) => {
      form.addEventListener('submit', (event) => event.preventDefault());
    });
    const button = searchUi.querySelector('button, input[type="submit"]');
    if (button) {
      button.setAttribute('type', 'button');
      button.addEventListener('click', (event) => event.preventDefault());
    }
  });

  const catalogScript = document.querySelector('script[src*="second-page-epson-catalog"]');
  const epsonCatalog = window.IR_SECOND_PAGE_CATALOGS?.epson;
  const epsonCatalogIsComplete =
    pageHandle === 'epson' && catalogScript && epsonCatalog
      ? catalogIsComplete(
          'EPSONインク型番',
          (epsonCatalog.ink?.length || 0) + (epsonCatalog.maintenance?.length || 0),
          epsonCatalog.sourceCount
        )
      : false;
  if (epsonCatalogIsComplete) {
    const imageUrl = (filename) => new URL(filename, catalogScript.src).href;
    const cardMarkup = (item) => {
      const label = item.labelHtml
        .split('<br>')
        .map(escapeHtml)
        .join('<br>');
      return `<a class="ik-model-card" href="${escapeHtml(item.shopifyUrl)}"><img src="${escapeHtml(imageUrl(item.image))}" alt="${escapeHtml(item.imageAlt)}" width="220" height="100" loading="lazy"><span class="px-3 py-3 text-center text-base font-bold">${label}</span></a>`;
    };
    const modelSections = Array.from(root.querySelectorAll('section')).filter((section) => {
      const heading = normalizeText(section.querySelector(':scope > h2')?.textContent);
      return /インク型番一覧|メンテナンスボックス/.test(heading) && section.querySelector('.grid');
    });
    const inkSection = modelSections.find((section) => /インク型番一覧/.test(normalizeText(section.querySelector(':scope > h2')?.textContent)));
    const maintenanceSection = modelSections.find((section) => /メンテナンスボックス/.test(normalizeText(section.querySelector(':scope > h2')?.textContent)));
    const replaceGrid = (label, section, items) => {
      const grid = section?.querySelector('.grid');
      if (!grid) {
        console.warn(`[second-page] ${label} の一覧が見つかりません。置き換えを中止しました。`);
        return;
      }
      if (!items?.length) {
        console.warn(`[second-page] ${label} の正本データが空です。置き換えを中止しました。`);
        return;
      }
      grid.innerHTML = items.map(cardMarkup).join('');
      grid.dataset.secondModelGrid = '';
      grid.dataset.sourceElementCount = String(items.length);
    };
    replaceGrid('EPSONインク型番一覧', inkSection, epsonCatalog.ink);
    replaceGrid('EPSONメンテナンスボックス一覧', maintenanceSection, epsonCatalog.maintenance);

    // 現行HTMLではYJシリーズ全体がコメントアウトされている。移行本文だけで
    // 誤って表示対象になっているため、現行の表示状態に合わせて除外する。
    root.querySelectorAll('article').forEach((article) => {
      const heading = normalizeText(article.querySelector(':scope > h3')?.textContent);
      if (heading === 'YJシリーズ') article.remove();
    });

    // 現行サイトには存在しない移行作業メモだけを除外し、現行由来の注記は残す。
    root.querySelectorAll('p').forEach((paragraph) => {
      const paragraphText = normalizeText(paragraph.textContent);
      if (/^現行EPSONページと同様に/.test(paragraphText)) {
        paragraph.remove();
        return;
      }
      if (/現行ページと同様に/.test(paragraphText)) {
        const preservedText = paragraphText
          .replace(/現行ページと同様に、型番は省略せずシリーズごとに並べます。?/, '')
          .trim();
        if (preservedText) paragraph.textContent = preservedText;
        else paragraph.remove();
      }
    });
  }

  // 独立したプリンター型番ページは旧本文の更新時期が異なるため、保存済みの
  // 現行HTMLから生成した正本データで一覧だけを補完する。
  const printerCatalog = pageHandle ? window.IR_SECOND_PAGE_PRINTER_CATALOGS?.[pageHandle] : null;
  if (printerCatalog) {
    const listHeading = Array.from(root.querySelectorAll('h2')).find((heading) =>
      /プリンター型番一覧/.test(normalizeText(heading.textContent))
    );
    const listSection = listHeading?.closest('section');
    const currentGrid = listSection?.querySelector(':scope > .grid');
    const printerModelTotal = printerCatalog.groups.reduce(
      (sum, group) => sum + (group.models?.length || 0),
      0
    );
    if (!currentGrid) {
      console.warn('[second-page] プリンター型番一覧が見つかりません。置き換えを中止しました。');
    }
    if (
      currentGrid &&
      catalogIsComplete('プリンターシリーズ', printerCatalog.groups.length, printerCatalog.groupCount) &&
      catalogIsComplete('プリンター型番', printerModelTotal, printerCatalog.modelCount)
    ) {
      currentGrid.innerHTML = printerCatalog.groups
        .map((group) => {
          const models = group.models
            .map(
              (model) =>
                `<li><a class="ik-anywhere flex min-h-10 items-center justify-center rounded border border-ink-grayLine bg-white px-2 py-2 text-center text-xs font-bold leading-5 text-ink-blue hover:border-ink-blue lg:px-3 lg:text-sm" href="${escapeHtml(model.shopifyUrl)}">${escapeHtml(model.model)}</a></li>`
            )
            .join('');
          return `<article class="rounded border border-ink-grayLine bg-white p-4"><h3 class="border-b border-ink-grayLine pb-2 text-lg font-bold text-ink-green">${escapeHtml(group.name)}</h3><ul class="mt-3 grid grid-cols-2 gap-2 text-ink-blue sm:grid-cols-3 lg:grid-cols-5">${models}</ul></article>`;
        })
        .join('');
      currentGrid.dataset.sourceGroupCount = String(printerCatalog.groupCount);
      currentGrid.dataset.sourceModelCount = String(printerCatalog.modelCount);
    }
  }

  // その他メーカーのトナープリンター一覧は複数メーカーを1ページに持つ。
  // 移行本文の抽出漏れを避けるため、現行HTMLの14セクションを正本として復元する。
  const printerSectionCatalog = pageHandle
    ? window.IR_SECOND_PAGE_PRINTER_SECTION_CATALOGS?.[pageHandle]
    : null;
  if (printerSectionCatalog) {
    const currentSections = Array.from(root.querySelectorAll('section')).filter((section) =>
      /レーザープリンター型番一覧/.test(
        normalizeText(section.querySelector(':scope > h2')?.textContent)
      )
    );
    const firstSection = currentSections[0];
    const sectionModelTotal = printerSectionCatalog.sections.reduce(
      (sum, section) =>
        sum +
        (section.groups || []).reduce((groupSum, group) => groupSum + (group.models?.length || 0), 0),
      0
    );
    const sectionGroupTotal = printerSectionCatalog.sections.reduce(
      (sum, section) => sum + (section.groups?.length || 0),
      0
    );
    // 差し替えは連続した兄弟セクションを丸ごと入れ替える前提。間に別の
    // セクションが挟まると表示順が変わるため、その場合は移行本文を残す。
    const sectionsAreAdjacent = currentSections.every(
      (section, index) => index === 0 || section.previousElementSibling === currentSections[index - 1]
    );
    if (firstSection && !sectionsAreAdjacent) {
      console.warn('[second-page] レーザープリンター型番一覧の間に別セクションがあります。表示順を崩さないため置き換えを中止しました。');
    }
    if (
      firstSection &&
      sectionsAreAdjacent &&
      catalogIsComplete('レーザープリンターセクション', printerSectionCatalog.sections.length, printerSectionCatalog.sectionCount) &&
      catalogIsComplete('レーザープリンターシリーズ', sectionGroupTotal, printerSectionCatalog.groupCount) &&
      catalogIsComplete('レーザープリンター型番', sectionModelTotal, printerSectionCatalog.modelCount)
    ) {
      const sectionMarkup = printerSectionCatalog.sections
        .map((section) => {
          const note = section.note
            ? `<p class="mt-4 text-sm leading-7 text-gray-700">${escapeHtml(section.note)}</p>`
            : '';
          const groups = section.groups
            .map((group) => {
              const models = group.models
                .map(
                  (model) =>
                    `<li><a class="ik-anywhere flex min-h-10 items-center justify-center rounded border border-ink-grayLine bg-white px-2 py-2 text-center text-xs font-bold leading-5 text-ink-blue hover:border-ink-blue lg:px-3 lg:text-sm" href="${escapeHtml(model.shopifyUrl)}">${escapeHtml(model.model)}</a></li>`
                )
                .join('');
              return `<article class="rounded border border-ink-grayLine bg-white p-4"><h3 class="border-b border-ink-grayLine pb-2 text-lg font-bold text-ink-green">${escapeHtml(group.name)}</h3><ul class="mt-3 grid grid-cols-2 gap-2 text-ink-blue sm:grid-cols-3 lg:grid-cols-5">${models}</ul></article>`;
            })
            .join('');
          return `<section class="mt-12" data-component="second-page-printer-list"><h2 class="border-b-4 border-ink-green pb-3 text-xl font-bold">${escapeHtml(section.title)}</h2>${note}<div class="mt-5 grid gap-4">${groups}</div></section>`;
        })
        .join('');
      firstSection.insertAdjacentHTML('beforebegin', sectionMarkup);
      currentSections.forEach((section) => section.remove());
      const restoredSections = root.querySelectorAll(
        '[data-component="second-page-printer-list"]'
      );
      if (restoredSections.length === printerSectionCatalog.sectionCount) {
        restoredSections[0].dataset.sourceSectionCount = String(
          printerSectionCatalog.sectionCount
        );
        restoredSections[0].dataset.sourceGroupCount = String(
          printerSectionCatalog.groupCount
        );
        restoredSections[0].dataset.sourceModelCount = String(
          printerSectionCatalog.modelCount
        );
      }
    }
  }

  // Canonトナー移行時に見出し外へ分断されたカードを、表示順のまま主一覧へ戻す。
  if (pageHandle === 'canon-t') {
    const cardSections = Array.from(root.querySelectorAll('section')).filter((section) =>
      section.querySelector(':scope .grid > .ik-model-card')
    );
    const mainSection = cardSections.find((section) => {
      const heading = normalizeText(section.querySelector(':scope > h2')?.textContent);
      return /トナーカートリッジ一覧|トナー型番一覧/.test(heading) && !/人気/.test(heading);
    });
    const mainGrid = mainSection?.querySelector(':scope .grid');
    if (mainGrid) {
      const mainIndex = cardSections.indexOf(mainSection);
      cardSections.slice(mainIndex + 1).forEach((section) => {
        if (section.querySelector(':scope > h2')) return;
        const grid = section.querySelector(':scope .grid');
        if (!grid) return;
        Array.from(grid.querySelectorAll(':scope > .ik-model-card')).forEach((card) => mainGrid.append(card));
        if (!grid.children.length) section.remove();
      });
      mainGrid.dataset.secondModelGrid = '';
      mainGrid.dataset.sourceElementCount = String(mainGrid.querySelectorAll(':scope > .ik-model-card').length);
    }
  }

  root.querySelectorAll('.grid').forEach((grid) => {
    if (grid.querySelector(':scope > .ik-model-card')) {
      grid.dataset.secondModelGrid = '';
    }
  });

  root.querySelectorAll('section').forEach((section) => {
    const heading = section.querySelector(':scope > h2');
    if (!heading) return;
    const text = normalizeText(heading.textContent);
    if (/プリンター型番/.test(text)) section.dataset.component = 'second-page-printer-list';
    if (/トナーカートリッジ|トナー型番|シリーズ/.test(text)) section.dataset.secondMakerSection = '';
  });

  if (root.classList.contains('ink-page-second--search-printer-t')) {
    const content = root.querySelector('.mx-auto');
    const links = content ? Array.from(content.querySelectorAll('a')) : [];
    const printerLinks = links.filter((link) => /レーザープリンター型番からトナーカートリッジを検索/.test((link.textContent || '').replace(/\s+/g, ' ').trim()));
    printerLinks.forEach((link) => { link.dataset.secondPrinterLink = ''; });
    const parent = printerLinks[0]?.parentElement;
    if (parent && printerLinks.every((link) => link.parentElement === parent)) parent.dataset.secondPrinterGrid = '';
  }

  root.querySelectorAll('a').forEach((link) => {
    if (link.querySelector(':scope > img')) {
      link.dataset.secondImageLink = '';
    }
    const text = normalizeText(link.textContent);
    if (text === 'レーザープリンター型番はこちら') {
      link.dataset.secondLaserLink = '';
      link.dataset.secondIndexLink = '';
      if (link.parentElement) link.parentElement.dataset.secondIndexLinks = '';
      return;
    }

    if (!text.includes('インク型番一覧') && !text.includes('プリンター型番一覧')) return;
    const parent = link.parentElement;
    if (!parent) return;
    const siblingTexts = Array.from(parent.children).map((node) => (node.textContent || '').replace(/\s+/g, ' ').trim());
    if (!siblingTexts.some((value) => value.includes('インク型番一覧')) || !siblingTexts.some((value) => value.includes('プリンター型番一覧'))) return;
    parent.dataset.secondIndexLinks = '';
    Array.from(parent.children).forEach((node) => {
      if (node.tagName === 'A') node.dataset.secondIndexLink = '';
    });
  });
})();
